"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Campaign() {
  const headlineWords = [{
    text: "Equality",
    italic: false
  }, {
    text: "is",
    italic: false
  }, {
    text: "a",
    italic: false
  }, {
    text: "human",
    italic: false
  }, {
    text: "right.",
    italic: true
  }];
  const {
    ref: labelRef,
    isVisible: labelVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.15
  });
  const {
    ref: introRef,
    isVisible: introVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.2
  });
  const {
    ref: image1Ref,
    isVisible: image1Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: image2Ref,
    isVisible: image2Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="2777" id="womensequalitycampaignbanner" className="bg-background text-foreground relative min-h-[85vh] w-full overflow-hidden py-20 md:py-28 lg:py-32">
      <div className="mx-auto max-w-[1440px] px-6 md:px-10 lg:px-16">
        {}
        <div ref={labelRef} className={`mb-12 md:mb-20 transition-all duration-700 ease-out ${labelVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <span className="font-default text-xs md:text-sm uppercase tracking-[0.18em] text-green-700">
            § awareness — women's equality campaign
          </span>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8 relative">
          {}
          <div aria-hidden="true" className="hidden lg:block absolute top-0 bottom-0 left-[58.33%] w-px bg-green-900/20" />

          {}
          <div className="lg:col-span-7 flex flex-col justify-center">
            <h1 ref={headlineRef} className="font-default font-bold leading-[0.92] tracking-tight text-green-950" style={{
            fontSize: "clamp(56px, 12vw, 176px)"
          }}>
              {headlineWords.map((word, i) => <span key={i} data-index={i} className="inline-block overflow-hidden align-bottom mr-[0.18em]" style={{
              paddingBottom: "0.08em"
            }}>
                  <span className={`inline-block transition-all ease-out ${word.italic ? "italic" : ""} ${headlineVisible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"}`} style={{
                transitionDuration: "700ms",
                transitionDelay: `${i * 80}ms`,
                color: word.italic ? "var(--primary)" : "inherit"
              }}>
                    {word.text}
                  </span>
                </span>)}
            </h1>

            <p ref={introRef} className={`font-default mt-10 md:mt-14 max-w-[36ch] text-base md:text-lg leading-relaxed transition-all duration-1000 delay-300 ease-out text-green-800 ${introVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              We are dedicated to keeping awareness issues forever fresh. Join us in advocating for systemic change and supporting women's rights globally.
            </p>
          </div>

          {}
          <div className="lg:col-span-5 flex flex-col justify-center gap-8 lg:gap-10 lg:pl-6">
            {}
            <figure ref={image1Ref} className={`transition-all duration-1000 ease-out ${image1Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <div className="overflow-hidden rounded-lg bg-green-100 shadow-md">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717563/img/equality_march_protest.png" alt="Women marching for equality in a peaceful demonstration" loading="lazy" decoding="async" className="w-full h-auto object-cover aspect-[4/5]" />
              </div>
              <figcaption className="mt-3 font-default text-[11px] md:text-xs uppercase tracking-[0.16em] text-green-700">
                plate i. / advocacy in motion
              </figcaption>
            </figure>

            {}
            <figure ref={image2Ref} className={`ml-auto w-[72%] transition-all duration-1000 delay-200 ease-out ${image2Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <div className="overflow-hidden rounded-lg bg-green-100 shadow-md">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717563/img/community_support_circle.png" alt="Diverse group of women supporting each other in a community circle" loading="lazy" decoding="async" className="w-full h-auto object-cover aspect-square" />
              </div>
              <figcaption className="mt-3 font-default text-[11px] md:text-xs uppercase tracking-[0.16em] text-green-700">
                plate ii. / community strength
              </figcaption>
            </figure>
          </div>
        </div>
      </div>
    </section>;
}